import { render, staticRenderFns } from "./SaleReturn.vue?vue&type=template&id=15db3ed8&"
import script from "./SaleReturn.vue?vue&type=script&lang=js&"
export * from "./SaleReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports